module.exports = __webpack_public_path__ + "db7468a626d02f5d70ff55636ac8cef1.svg";